import React, { useEffect } from "react";
import Script from "next/script";
import Layout from "components/Layout";
import { get_tdk } from "api/server/tdk";
import {Util,Context,Hooks} from "@xt/xtbase";
const {getOrigin} = Util;
const {useTranslation} = Hooks;
import FinanceHead from "@/components/Pages/Finance/FinanceHead";
import FinanceFaq from "@/components/Pages/Finance/FinanceFaq";
import ModalSubscribe from "@/components/Pages/Finance/ModalSubscribe";
import PageSavings from "@/components/Pages/Finance/PageSavings";
import models from "@/models";

export default (props)=>{
  models?.finance?.setScope("SAVING");
  const t = useTranslation();
  return (
    <>
      <Script
        id="jsonLd"
        type="application/ld+json"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            {
              "@context":"http://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": "${t('finance.faqSavings1').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSavings1Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSavings2').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSavings2Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSavings3').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSavings3Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSavings4').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSavings4Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSavings5').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSavings5Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSavings6').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSavings6Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSavings7').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSavings7Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSavings8').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSavings8Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSavings9').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSavings9Answer').replace(/\"/g,'')}</p>"
                }
              }]
            }
          `,
        }}
      />
      <Layout style={{overflow: "hidden"}}>
        <FinanceHead category={1}/>
        <PageSavings/>
        <FinanceFaq category={1}/>
        <ModalSubscribe/>
      </Layout>
    </>
  );
}
export async function getStaticProps(context){
  const resolvedUrl = "/finance/savings";
  const props = {resolvedUrl,theme:"dark"};
  try{
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  }
  catch(error)
  {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate:60
  }
}



